import { render, staticRenderFns } from "./StorageDetail.vue?vue&type=template&id=496d9072&"
import script from "./StorageDetail.vue?vue&type=script&lang=ts&"
export * from "./StorageDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports